module.exports = __webpack_public_path__ + "img/default.03155a40.png";